import { c as _c } from "react/compiler-runtime";
import type { Color } from '@onefootprint/design-tokens';
import { IcoCheck16, IcoClose16, IcoDotSmall16, IcoInfo16, type Icon, IcoWarning16 } from '@onefootprint/icons';
import type { UserTimelineEventWatchlistCheck, WatchlistCheckStatusKind } from '@onefootprint/request-types/dashboard';
import { useTranslation } from 'react-i18next';
import EventBodyEntry from '../event-body-entry';
type WatchlistCheckEventBodyProps = {
  data: UserTimelineEventWatchlistCheck['data'];
  lineHeight?: 'default' | 'large';
  showIcons?: boolean;
};
const textColors: Record<WatchlistCheckStatusKind, Color> = {
  pass: 'success',
  fail: 'error',
  not_needed: 'primary',
  error: 'warning',
  pending: 'primary',
  repeated_hits: 'primary',
  initial_kyc_record: 'primary'
};
const statusIcons: Record<WatchlistCheckStatusKind, Icon> = {
  pass: IcoCheck16,
  fail: IcoWarning16,
  not_needed: IcoInfo16,
  error: IcoClose16,
  pending: IcoInfo16,
  repeated_hits: IcoInfo16,
  initial_kyc_record: IcoInfo16
};
const WatchlistCheckEventBody = t0 => {
  const $0 = _c(14);
  const {
    data,
    lineHeight: t1,
    showIcons
  } = t0;
  const lineHeight = t1 === undefined ? "large" : t1;
  let t2;
  if ($0[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      keyPrefix: "auditTrail.timeline.watchlistCheckEvent"
    };
    $0[0] = t2;
  } else {
    t2 = $0[0];
  }
  const {
    t
  } = useTranslation("entity-details", t2);
  const {
    status
  } = data;
  const color = textColors[status];
  const iconComponent = showIcons ? statusIcons[status] : IcoDotSmall16;
  let t3;
  if ($0[1] !== status) {
    t3 = $ => $.status[status];
    $0[1] = status;
    $0[2] = t3;
  } else {
    t3 = $0[2];
  }
  let t4;
  if ($0[3] !== t || $0[4] !== t3) {
    t4 = t(t3);
    $0[3] = t;
    $0[4] = t3;
    $0[5] = t4;
  } else {
    t4 = $0[5];
  }
  const statusStr = t4 as string;
  const t5 = `text-body-2 mr-0.5 text-${color}`;
  let t6;
  if ($0[6] !== statusStr || $0[7] !== t5) {
    t6 = <div className="flex items-center justify-start gap-1"><span className={t5}>{statusStr}</span></div>;
    $0[6] = statusStr;
    $0[7] = t5;
    $0[8] = t6;
  } else {
    t6 = $0[8];
  }
  let t7;
  if ($0[9] !== color || $0[10] !== iconComponent || $0[11] !== lineHeight || $0[12] !== t6) {
    t7 = <EventBodyEntry iconComponent={iconComponent} iconColor={color} lineHeight={lineHeight} content={t6} testID="watchlist-check-event-body" />;
    $0[9] = color;
    $0[10] = iconComponent;
    $0[11] = lineHeight;
    $0[12] = t6;
    $0[13] = t7;
  } else {
    t7 = $0[13];
  }
  return t7;
};
export default WatchlistCheckEventBody;